import React from 'react';
import BlogContainer from './BlogContainer';

function RecentBlogPosts() {
    return (
        <>
            <div className="related-posts">
                <div className="container">
                    <div className="related-posts--heading">
                        <h2>Recent activities</h2>
                    </div>

                    <BlogContainer numberOfPosts={3} width="4" />
                </div>
            </div>
        </>
    );
}

export default RecentBlogPosts; 